import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import styles from "./index.module.css";

/*
 * Item displaying information for the session attendance report table
 */
export default function ReportItemSessionAttendance({ item, isOdd }) {
  return (
    <div className={classNames(styles.iboItem, isOdd && styles.odd)}>
      <div className={styles.ibo}>{item.IBO}</div>
      <div className={styles.iboALastName}>{item.lastName}</div>
      <div className={styles.iboAFirstName}>{item.firstName}</div>
      <div className={styles.ticket}>{item.ticket}</div>
      <div className={styles.diamond}>{item.diamond}</div>
    </div>
  );
}

ReportItemSessionAttendance.propTypes = {
  item: PropTypes.shape({
    IBO: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    ticket: PropTypes.string,
    diamond: PropTypes.string,
  }),
  isOdd: PropTypes.bool,
};
